var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.295,
    height: 24.302,
    viewBox: "0 0 24.295 24.302",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    d: "M23.721,3.083l-.054-.054L20.748.489a1.924,1.924,0,0,0-1.54-.513A2.34,2.34,0,0,0,17.8.624l-.081.081L14.858,4.326a2.031,2.031,0,0,0,.054,2.837.717.717,0,0,0,.162.135l1.459.973c-.108.513-.865,1.973-3.54,4.648-2.648,2.648-4.107,3.4-4.621,3.513L7.4,14.973a.716.716,0,0,0-.135-.162,2.057,2.057,0,0,0-2.837-.054L.833,17.621.752,17.7a2.172,2.172,0,0,0-.135,2.945l2.54,2.891.054.054a2.89,2.89,0,0,0,2.081.676,12.266,12.266,0,0,0,4.08-.946,25.358,25.358,0,0,0,8.458-5.675A25.89,25.89,0,0,0,23.5,9.19C23.991,7.839,25.126,4.488,23.721,3.083ZM16.263,16.162c-5,5-10.593,6.377-11.566,5.918L2.238,19.243h0l3.513-2.783L6.7,17.891c.027.027.027.054.054.081a1.748,1.748,0,0,0,1.324.649c.513.027,2.108.108,6.4-4.188,1.054-1.054,4.3-4.3,4.188-6.4A1.841,1.841,0,0,0,18.019,6.7c-.027-.027-.054-.054-.081-.054L16.56,5.677l2.783-3.54h0L22.154,4.6C22.64,5.542,21.262,11.163,16.263,16.162Z",
    transform: "translate(-0.104 0.034)",
    fill: "#263984"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.1d5fa16c.svg";
export { ForwardRef as ReactComponent };